import type { ViewPortContextIntegrationApi } from '@/components/componentsIntegration/ViewPortContextApi';
import type { Dispatch, SetStateAction } from 'react';

import { useState } from 'react';
import { ContextEvents } from '@/engine/app/modules/images/interfaces.ts';

type ContextMenu = {
  mouseX: number;
  mouseY: number;
} | null;

export function useContextMenu(
  contextApi: ViewPortContextIntegrationApi
): [
  ContextMenu,
  ContextEvents,
  Dispatch<SetStateAction<ContextEvents>>,
  (event: MouseEvent) => void,
  () => void,
  () => void,
  () => void,
  () => void
] {
  const [contextMenu, setContextMenu] = useState<ContextMenu>(null);

  const [contextMode, setContextMode] = useState<ContextEvents>(ContextEvents.NONE);

  const handleContextMenu = (event: MouseEvent): void => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null && contextMode !== ContextEvents.NONE
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6
          }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
          // Other native context menus might behave different.
          // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
          null
    );
  };

  const handleContextClose = (): void => {
    setContextMenu(null);
  };

  const handleRemove = (): void => {
    contextApi.performContextCommand(ContextEvents.REMOVE);
    setContextMenu(null);
  };

  const handleAdd = (): void => {
    contextApi.performContextCommand(ContextEvents.ADD);
    setContextMenu(null);
  };

  const handleReIndicate = (): void => {
    contextApi.performContextCommand(ContextEvents.REINDICATE);
    setContextMenu(null);
  };

  return [
    contextMenu,
    contextMode,
    setContextMode,
    handleContextMenu,
    handleContextClose,
    handleRemove,
    handleAdd,
    handleReIndicate
  ];
}
